import React from 'react';
import './TextBox.css';

const TextBox = () => {
  return (
    <div className="text-box">
      <div className="text-box-content">
        <div className="bullet-item">• Automating the Manufacturing Industry at Endeavor</div>        
        <div className="bullet-item">• Postgraduate student studying High Performance Computing</div>
        <div className="bullet-item"><strong><em>Previously</em></strong></div>
        <div className="bullet-item">• Machine Learning Engineer at SAIC</div>
        <div className="bullet-item">• Research Collaborator at Human Union Data (YC W25)</div>
        <div className="bullet-item">• Co-authored The Observed Availability of Data and Code in Earth Science and Artificial Intelligence</div>
        <div className="bullet-item">• Research Fellow at Stanford Center for Human Rights collaborating with UNHCR</div>
        <div className="bullet-item">• Research Assistant at Stanford University analyzing 1.5TB+ cellular datasets</div>
        <div className="bullet-item">• Won 2nd Place at HackHarvard</div>
      </div>
    </div>
  );
};

export default TextBox;
